import {getAdmitadQueries} from '@/app/js/admitad'

export function handleStoreChanging() {
  document.querySelectorAll('.js-change-store-link').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault()

      const href = link.dataset.href + location.pathname.replace(/^\//, '')

      const searchParams = new URLSearchParams({
        ...getAdmitadQueries(),
        came_from_header_menu: 'true',
      })

      location.assign(href + '?' + searchParams.toString())
    })
  })
}
